// src/components/Footer.js
import React from 'react';
import './Footer.css';
import { FaWhatsapp } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        {/*<p>CustomSoft Solutions - Desarrollo de software en Paraná, Concordia, Gualeguaychú y Entre Ríos</p>*/}
        <p>CustomSoft Solutions - Desarrollo de software a medida</p>
        <p>Contacto: <a href="mailto:contacto@customsoft-solutions.com.ar">contacto@customsoft-solutions.com.ar</a></p>
        {/*<div className="footer-whatsapp">
          <a href="https://wa.me/543433007049" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className="whatsapp-icon" /> +54 343 3007049
          </a>        
        </div>*/}
      </div>
    </footer>
  );
}

export default Footer;
